export enum RaftInfoEvents {
    RAFT_NAME = 'RAFT_NAME',
    SYSTEM_INFO = 'SYSTEM_INFO',
    STATE_INFO = 'STATE_INFO',
    RAFT_VERSION = 'RAFT_VERSION',
    RAFT_SERIAL_NO = 'RAFT_SERIAL_NO',
    RAFT_MSG = 'RAFT_MSG',
    IS_REGISTERED_TO_WARRANTY = 'IS_REGISTERED_TO_WARRANTY',
    RAFT_IS_VERIFIED = 'RAFT_IS_VERIFIED',
}